import { Locale } from "@/i18n";

/**
 * Italian-style URL slugs taken from the original Laravel routes.
 * We keep them identical across locales so links match the live site.
 */
export const ROUTES = {
  home: "",
  about: "about-us",
  products: "prodotti",
  projects: "progetti",
  catalogues: "cataloghi",
  stock: "stock",
  news: "news",
  showroom: "showroom",
  contact: "contatti",
  privacy: "privacy-policy",
  cookies: "cookie-policy",
} as const;

export type RouteKey = keyof typeof ROUTES;

export function localePath(locale: Locale, key: RouteKey, ...rest: string[]) {
  const parts = [locale, ROUTES[key], ...rest].filter(Boolean);
  return "/" + parts.join("/");
}

export const PRODUCT_FAMILIES = ["classic", "contemporary", "textile"] as const;
export type ProductFamily = (typeof PRODUCT_FAMILIES)[number];

export const PRODUCT_LEAVES: Record<ProductFamily, readonly string[]> = {
  classic: ["furniture", "kitchens", "wardrobe", "office", "libraries", "boiserie"],
  contemporary: ["furniture", "kitchens", "wardrobe", "bathroom"],
  textile: ["curtains", "bedspreads", "tablecovers", "cushions"],
};